import React, { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { Form, useFieldValue } from '@kuzmycz/react-form-ula';
import { Button, Modal } from '../../../../Components/uielements';
import BioPlusTextField from '../../../../Components/form-fields/BioPlusTextField';
import DropDown from '../../../../Components/uielements/dropDown';
import {
  ModalGap,
  OutlineButton,
  TwoColumns,
} from '../../../../services/settings/appStyle/global.style';
import { ModalWrapper, ModalButtonWrapper, Columns, GapColums } from '../Subscription.style';

import SubscriptionPlanService from '../../../../services/bioplus-services/subscription-plan';
import { IntlMessages } from '../../../../helper/langHelper';
import { ArrayOfQuantity } from '../constant';
import { ModalTitle } from '../../../../Components/uielements/modal/modal.style';

const getSubscriptionPlanUrlBasedOnEditOrCreate = async (values) => {
  return await SubscriptionPlanService.createPlan(values);
};

const FeatureWithAddOnCondition = ({ name, title, defaultValue, handleSelected, type }) => {
  const [extraType] = useFieldValue(`${name}.type`);
  const Type = type || extraType;

  return (
    <>
      <DropDown
        selectedOption={handleSelected}
        options={ArrayOfQuantity}
        name={`${name}.type`}
        defaultValue={defaultValue}
        label={title}
      />
    </>
  );
};

const AddOnPlan = ({ onClose, data }) => {
  const [selectedBillingPeriod, setSelectedBillingPeriod] = useState();
  const [selectedAddOnFeature, setSelectedAddOnFeature] = useState('user');

  const [addOnQty, setAddOnQty] = useState();
  const queryClient = useQueryClient();

  const mutation = useMutation((values) => getSubscriptionPlanUrlBasedOnEditOrCreate(values), {
    onSuccess: async () => {
      await queryClient.invalidateQueries('subscriptionPlans');
      onClose();
    },
    onError: (error) => {
      alert(`Error: ${error?.response?.data?.message}`);
      onClose();
    },
  });

  const handleSubmit = (values) => {
    const value = {
      ...values,
      ...{ type: 'addOn' },
      addOn: selectedAddOnFeature,
      qty: Number(addOnQty),
    };
    mutation.mutate(value);
  };

  const validator = (values) => {
    return undefined;
  };

  const handleSelectedBillingPeriod = (value) => {
    setSelectedBillingPeriod(value);
  };

  const handleSelectedAddOnFeature = (value) => {
    setSelectedAddOnFeature(value?.value);
  };

  const handleSelectedAddOnQty = (value) => {
    setAddOnQty(value.value);
  };

  return (
    <>
      <Modal
        isOpen={true}
        onClose={onClose}
        isUppercase={true}
        title={<IntlMessages id="button.text.add.on" />}
      >
        <Form initialValues={data} validator={validator} onSubmit={handleSubmit}>
          <ModalWrapper>
            <ModalGap>
              <TwoColumns></TwoColumns>
              <Columns>
                <DropDown
                  selectedOption={handleSelectedBillingPeriod}
                  options={[{ label: 'Monthly', value: 'month' }]}
                  name="billingPeriod"
                  defaultValue={data.billingPeriod}
                  label={<IntlMessages id="input.label.BillingPeriod" />}
                  isDropDownNotClickable={true}
                />
                <BioPlusTextField name="baseCost" label="Base Cost" fullWidth />
              </Columns>
              <TwoColumns></TwoColumns>
              <ModalTitle size="header3" isNotCapitalize={false} isUppercase={true}>
                Additional Services
              </ModalTitle>
              <GapColums>
                <DropDown
                  selectedOption={handleSelectedAddOnFeature}
                  options={[
                    { label: 'Member', value: 'user' },
                    { label: 'Timesheet', value: 'timesheet' },
                    { label: 'eDEC’s', value: 'edec' },
                  ]}
                  name="addOn"
                  label={'Select the feature'}
                  defaultValue={selectedAddOnFeature}
                />
                {selectedAddOnFeature && (
                  <FeatureWithAddOnCondition
                    title={selectedAddOnFeature}
                    defaultValue={0}
                    handleSelected={handleSelectedAddOnQty}
                  />
                )}
              </GapColums>
            </ModalGap>
            <ModalButtonWrapper>
              <OutlineButton onClick={onClose}>
                <IntlMessages id="modal.button.cancel" />
              </OutlineButton>
              <Button varient="normal" type="submit">
                Add On
              </Button>
            </ModalButtonWrapper>
          </ModalWrapper>
        </Form>
      </Modal>
    </>
  );
};

export default AddOnPlan;
